import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
// tslint:disable-next-line:ordered-imports
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Order, OrderItem, OrderResponse } from '../models/orderResponse';

import { STEP_STATE } from '@angular/cdk/stepper';
import { HttpErrorResponse } from '@angular/common/http';
import { MatStepper } from '@angular/material/stepper';
import { AppConfig, BackendResponse, DeviceService, DialogService, HttpService, ScreenSize, TranslateService } from 'vas-mobile-api';
import { SupplyCreateRequest } from '../models/supplyCreateRequest';
import { DataExchangeService } from '../services/dataexchange.service';
import { PrintService } from '../services/print.service';

@Component({
  selector: 'app-new-inbound-delivery',
  templateUrl: './new-inbound-delivery.component.html',
  styleUrls: ['./new-inbound-delivery.component.css']
})
export class NewInboundDeliveryComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    private _formBuilder: FormBuilder,
    private dataExChange: DataExchangeService,
    private translateService: TranslateService,
    private httpServcice: HttpService,
    private appConfig: AppConfig,
    private printService: PrintService,
    private router: Router,
    private dialogService: DialogService,
    private deviceService: DeviceService,
    private rd: Renderer2) {

    this.minLitre = this.dataExChange.getMinLitre();
    this.maxLitre = this.dataExChange.getMaxLitre();
    this.orderInfoNeeded = true; // this.dataExChange.getOrderInfo();

    this.mainFormGroup = this._formBuilder.group({
      productGrp: this.productFormGroup,
      driverGrp: this.driverFormGroup,
      weightsGrp: this.weightsFormGroup,
      extNumberGrp: this.extNumberFormGroup,
      remarkGrp: this.remarkFormGroup,

    });
  }
  public selectedProduct: OrderItem = {
    productId: '',
    productName: '',
    productDenotation: '',
    loadingType: '',
    isProductLiquid: false,
    isExtOrderIdRequired: false
  };
  @ViewChild(MatStepper, { static: false }) myStepper: MatStepper;
  public mainFormGroup: FormGroup;
  public showAdditionalInfo = false;
  private slideCount = 6;
  private activeSlide = 0;
  private sliderContainer: ElementRef;
  private sliderManager: HammerManager;
  private nextSlide = 0;
  private dateTomorrow: Date;
  public dateToday = new Date();
  public locale: string;

  private viewMode = 'ltr';
  public showMobile: boolean;
  private truckReg: RegExp = new RegExp('\\d{3,}\\s[^\\d]{3,}');
  public minLitre = 10001;
  public maxLitre = 50001;
  public orderInfoNeeded = true;
  public minTons = 5;
  public maxTons = 100;
  public readyToRender = false;
  private ngUnsubscribe: Subject<void> = new Subject();
  public orderFormGroup = this._formBuilder.group({
    orderCtrl: ['', Validators.required],
  });
  public productFormGroup = this._formBuilder.group({
    productCtrl: ['', Validators.required],
  });
  public driverFormGroup = this._formBuilder.group({
    // driverNameCtrl: ['', Validators.required],
    truckPlateNameCtrl: ['', [Validators.required, this.truckPlateValidator()]],
  });
  public weightsFormGroup = this._formBuilder.group({
    weightsCtrl: ['', [Validators.required, this.minMaxQuantityValidator()]],
  });
  public extNumberFormGroup = this._formBuilder.group({
    extNumberCtrl: ['', this.isOrderInfoMandatory()],
  });
  public remarkFormGroup = this._formBuilder.group({
    remarkCtrl: ['', Validators.required],
  });

  public orderData: any;
  public selectedOrder: Order = this.orderFormGroup.get('orderCtrl').value;

  public selectedProductList: OrderItem[] = [];
  ngOnInit() {
    this.dataExChange.showLoadingIndicator(true);
    this.httpServcice.get<BackendResponse<OrderResponse>>({
      pathId: 'getOrders', customTimeout: 1000000
    }).subscribe((result) => {
      this.dataExChange.showLoadingIndicator(false);
      this.orderData = result;
      console.log('getOrder ', result);
      this.readyToRender = true;
    }, (e: HttpErrorResponse) => {
      this.dataExChange.showLoadingIndicator(false);
      this.dialogService.openConfirmDialog(
        this.translateService.translateFirstLetterUpperCase('MESSAGE:ORDER_NOT_PLACED'),
        e.error ? e.error.message : e.message,
        this.translateService.translateFirstLetterUpperCase('BUTTON_OK')
      );
    });

    this.orderFormGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {

      console.log('DATA : ', data);
      console.log('DATA : ', data.orderCtrl);
      this.selectedProductList = data.orderCtrl.orderItems;
      this.selectedProduct = {
        productId: '',
        productName: '',
        productDenotation: '',
        loadingType: '',
        isProductLiquid: false,
        isExtOrderIdRequired: false
      };

      this.productFormGroup.setErrors({ invalid: true }, { emitEvent: true });
    });

    this.productFormGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((orderItem: any) => {

      console.log('DATA Item : ', orderItem);
      console.log('DATA Item : ', orderItem.productCtrl);
      this.selectedProduct = orderItem.productCtrl;

    });

    this.deviceService.size.pipe(takeUntil(this.ngUnsubscribe)).subscribe((size) => {
      this.showMobile = size <= ScreenSize.sm;
    });

    this.dataExChange.viewModeChange$.subscribe((viewMode) => {
      this.viewMode = viewMode;
    });
  }

  public checkIfLiquid(): string {
    if (this.selectedProduct.productId.trim().length === 0) { return ''; }
    if (this.selectedProduct.isProductLiquid) {
      return this.translateService.translate('LABEL_LIQUID');
    } else {
      return this.translateService.translate('LABEL_BULK');
    }
  }

  private truckPlateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;
      const result: any = {};
      if (!this.truckReg.test(value)) {
        result.wrongPlate = true;
      }
      return result;
    };

  }
  private isOrderInfoMandatory(): ValidatorFn {
    if (!this.selectedProduct.isExtOrderIdRequired) {
      return null;
    } else {
      return Validators.required;
    }

  // return (control: AbstractControl): { [key: string]: string } => {
  //   const value = control.value;
  //   const result: any = {};

  //   if (!this.orderInfoNeeded) {
  //     result.bestellInfoNeeded = true;
  //   } else {
  //     if (value.length >= 1) {
  //       result.bestellInfoNeeded = true;
  //     } else {
  //       result.bestellInfoNeeded = false;
  //     }
  //   }
  //   return result;
  // };

}

  private minMaxQuantityValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const value = +control.value;
    const result: any = {};
    if (this.selectedProduct) {
      if (this.selectedProduct.isProductLiquid) {
        if (isNaN(value)) {
          result.noNumber = true;
        }
        if (value < this.minLitre) {
          result.minimalLitre = { value: this.minLitre };
        }
        if (value > this.maxLitre) {
          result.maximalLitre = { value: this.maxLitre };
        }
        return result;
      } else {

        if (isNaN(value)) {
          result.noNumber = true;
        } else if (value < this.minTons) {
          result.minimalTons = { value: this.minTons };
        } else if (value > this.maxTons) {
          result.maximalTons = { value: this.maxTons };
        }
        return result;
      }
    } else {
      return result;
    }

  };

}

  public get truckCtrlErrors(): any {
  return this.driverFormGroup.get('truckPlateNameCtrl').errors || {};
}

  public get weightCtrlErrors(): any {
  return this.weightsFormGroup.get('weightsCtrl').errors || {};
}

getValueOfWeight(): string {
  let unit = '';
  if (this.selectedProduct.isProductLiquid) {
    unit = this.translateService.translate('LABEL_LITERS');
  } else {
    unit = this.translateService.translate('LABEL_TONS');
  }
  return '' + this.weightsFormGroup.get('weightsCtrl').value + ' ' + unit;
}

  public placeDelivery() {
  this.dataExChange.showLoadingIndicator(true);
  const sendingObject: SupplyCreateRequest = {
    licensePlate: this.driverFormGroup.get('truckPlateNameCtrl').value,
    orderId: this.orderFormGroup.get('orderCtrl').value.orderId,
    productId: this.selectedProduct.productId,
    quantity: this.weightsFormGroup.get('weightsCtrl').value,
    extOrderId: this.extNumberFormGroup.get('extNumberCtrl').value,
    driverName: this.driverFormGroup.get('truckPlateNameCtrl').value,
  };

  this.httpServcice.post<BackendResponse<string[]>>({
    pathId: 'createYCCInboundDelivery',
    payload: sendingObject, customTimeout: 1000000
  }).subscribe((result) => {
    this.dataExChange.showLoadingIndicator(false);
    this.print(result.data[0]);
    this.router.navigate(['dashboard']);
  }, (e: HttpErrorResponse) => {
    this.dataExChange.showLoadingIndicator(false);
    this.dialogService.openConfirmDialog(
      this.translateService.translateFirstLetterUpperCase('MESSAGE:ORDER_NOT_PLACED'),
      e.error ? e.error.message : e.message,
      this.translateService.translateFirstLetterUpperCase('BUTTON_OK')
    );
  }
  );
}

  private print(liefer_nr: string) {
  if (liefer_nr) {
    const reportId = this.appConfig.getValue<string>('reportSupLN');
    this.dataExChange.showLoadingIndicator(true);
    this.printService.printDNO(reportId, liefer_nr, this.showMobile).subscribe(() => {
      this.dataExChange.showLoadingIndicator(false);
    }, () => { }, () => {
      this.dataExChange.showLoadingIndicator(false);
    });
  }
}

  public ejectNewDelivery() {

  this.dialogService.openConfirmCancelDialog(
    this.translateService.translateFirstLetterUpperCase('LABEL_CONFIRMATION'),
    this.translateService.translateFirstLetterUpperCase('MESSAGE:CANCEL_DELIVERY'),
    this.translateService.translateFirstLetterUpperCase('BUTTON_YES'),
    this.translateService.translateFirstLetterUpperCase('BUTTON_NO')

  ).subscribe((res) => {
    if (res === true) {
      this.router.navigate(['dashboard']);
    }

  });

}

@ViewChild('slider1', { static: false }) set setSliderContainer(sliderContainer: ElementRef) {
  if (sliderContainer !== this.sliderContainer) {
    this.sliderContainer = sliderContainer;
    if (this.sliderManager) {
      this.sliderManager.off('panleft panright panend');
    }
    if (this.sliderContainer) {
      this.sliderManager = new Hammer(this.sliderContainer.nativeElement);
      this.sliderManager.get('pan').set({ threshold: 10, direction: Hammer.DIRECTION_HORIZONTAL });
      // this.sliderManager.add(new Hammer.Pan({ threshold: 10, direction: Hammer.DIRECTION_HORIZONTAL }));
      this.sliderManager.on('panleft panright', (e) => this.onPan(e));
      this.sliderManager.on('panend', (e) => this.onPanEnd(e));
    }
  }
}

  private onPan(e) {
  if (e.center.x !== 0 && e.center.y !== 0) {
    let percentage = 100 / this.slideCount * e.deltaX / window.innerWidth; // NEW: our % calc
    let transformPercentage;
    if (this.viewMode === 'rtl') {
      transformPercentage = percentage + 100 / this.slideCount * this.activeSlide; // NEW
    } else {
      transformPercentage = percentage - 100 / this.slideCount * this.activeSlide; // NEW
    }
    this.rd.setStyle(this.sliderContainer.nativeElement, 'transform', 'translateX(' + transformPercentage + '%)');

    if ((e.velocityX > 0.3 || e.velocityX < -0.3 || e.deltaX > 150 || e.deltaX < -150)) {
      if (this.viewMode === 'rtl') {
        // This is important for a change from rtl !!!!
        percentage = -percentage;
      }
      if (percentage < 0) {
        this.nextSlide = this.activeSlide + 1;
      } else if (percentage > 0) {
        this.nextSlide = this.activeSlide - 1;
      } else {
        this.nextSlide = this.activeSlide;
      }
    } else {
      this.nextSlide = this.activeSlide;
    }
  }
}

  private onPanEnd(e) {
  if (this.isSlideAllowed(this.nextSlide, this.activeSlide)) {
    this.goToSlide(this.nextSlide);
  } else {
    this.goToSlide(this.activeSlide);
  }
}

  private isSlideAllowed(nextSlide: number, activeSlide: number): boolean {
  if (nextSlide > activeSlide) {
    // going forward, check if current slide is valid
    switch (activeSlide) {
      case 0:
        return this.orderFormGroup.valid;
      case 1:
        return this.productFormGroup.valid;
      case 2:
        return this.driverFormGroup.valid;
      case 3:
        return this.weightsFormGroup.valid;
      case 4:
        return this.extNumberFormGroup.valid;
      default:
        return true;
    }

  } else {
    return true;
  }

}

  public goToSlide(slideNumber: number) {

  if (slideNumber < 0) {
    this.activeSlide = 0;
  } else if (slideNumber > this.slideCount - 1) {
    this.activeSlide = this.slideCount - 1;
  } else {
    this.activeSlide = slideNumber;
  }
  let percentage;

  if (this.viewMode === 'rtl') {
    percentage = +(100 / this.slideCount) * this.activeSlide;
  } else {
    percentage = -(100 / this.slideCount) * this.activeSlide;
  }
  // const percentage = -(100 / this.slideCount) * this.activeSlide;

  this.rd.setStyle(this.sliderContainer.nativeElement, 'transition', 'transform .3s');
  this.rd.setStyle(this.sliderContainer.nativeElement, 'transform', 'translateX(' + percentage + '%)');
  setTimeout(() => {
    this.rd.removeStyle(this.sliderContainer.nativeElement, 'transition');
  }, 300);

}

ngAfterViewInit() {
  this.myStepper._getIndicatorType = () => STEP_STATE.NUMBER;
}
ngOnDestroy(): void {
  this.ngUnsubscribe.next();
  this.ngUnsubscribe.complete();
}
}
